import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faFlag, faReply, faTrash, faCaretDown, faCaretRight, faEdit, faArrowsRotate } from '@fortawesome/pro-solid-svg-icons'
import { translate } from 'react-i18next';
import { Checkbox, notification } from 'antd';
import i18next from 'i18next';
import moment from 'moment';
import sanitizeHTML from 'sanitize-html';

import {
    FETCH_CONVERSATION_SUCCESS,
    BLOCK_USER_SUCCESS,
    SEND_MESSAGE_SUCCESS,
    UPDATE_MESSAGE_SUCCESS,
    DELETE_CONVERSATION_SUCCESS,
    SANITIZE_HTML_CONFIG,
    PAGE_SIZE
} from '../../messages/messageActions';

import SearchBar from 'Parts/search/SearchBarContainer';
import SelectField from 'Parts/ui/components/fields/SelectField';
import Wysiwyg from '../../parts/ui/components/fields/Wysiwyg';
import PaginationTop from 'Parts/search/PaginationTop';
import { getLanguageDateFormatByKey } from '../../parts/common/langUtils';

import userInboxEN from './locales/UserInbox_en.json';
import userInboxFR from './locales/UserInbox_fr.json';

import './UserInbox.less';

class UserInboxForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pager: {
                total: props.pagination ? props.pagination.totalResults : 0,
                current: props.pagination ? props.pagination.pageNumber : 1,
                pageSize: PAGE_SIZE
            },
            messages: props.messages,
            oldestFirst: false,
            editMode: false
        };

        this.scrollRef = React.createRef();

        i18next.addResourceBundle('en', 'UserInboxForm', userInboxEN);
        i18next.addResourceBundle('fr', 'UserInboxForm', userInboxFR);

        this.deselectConversation = this.deselectConversation.bind(this);
        this.markSelectedAsUnread = this.markSelectedAsUnread.bind(this);
        this.blockUser = this.blockUser.bind(this);
        this.reportMessage = this.reportMessage.bind(this);
        this.reply = this.reply.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleReplyTextChanged = this.handleReplyTextChanged.bind(this);
        this.send = this.send.bind(this);
        this.deleteReply = this.deleteReply.bind(this);
        this.openCloseMessage = this.openCloseMessage.bind(this);
        this.handleOrderChange = this.handleOrderChange.bind(this);
        this.deleteConversation = this.deleteConversation.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.enterEditMode = this.enterEditMode.bind(this);
        this.leaveEditMode = this.leaveEditMode.bind(this);
        this.confirmEdit = this.confirmEdit.bind(this);
        this.refreshList = this.refreshList.bind(this);
        this.getRecipients = this.getRecipients.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentWillUnmount() {
        this.props.clearSearch();
        const el = this.scrollRef.current;
        if (el) {
            el.removeEventListener('scroll', this.handleScroll);
        }
    }

    componentDidMount() {
        const el = this.scrollRef.current;
        if (el) {
            el.addEventListener('scroll', this.handleScroll);
        }
    }

    componentDidUpdate(prevProps) {
        // Update the pager with the new total
        let pager;

        if (this.props.pagination && (!prevProps.pagination || prevProps.pagination.pageNumber !== this.props.pagination.pageNumber || 
            prevProps.pagination.totalResults !== this.props.pagination.totalResults)) {
            pager = {
                ...this.state.pager,
                total: this.props.pagination.totalResults,
                current: this.props.pagination.pageNumber,
                pageSize: PAGE_SIZE
            };

            this.setState({ pager });
        }

        if(this.props.fetchTime && (!prevProps.fetchTime || prevProps.fetchTime !== this.props.fetchTime)) {
            this.setState({ messages: this.props.messages, fetchTime: this.props.fetchTime })
        }


        if (this.props.conversationFetchTime && (!prevProps.conversationFetchTime || prevProps.conversationFetchTime !== this.props.conversationFetchTime ||
            (!this.state.selectedConversation && this.state.conversationFetchTime !== this.props.conversationFetchTime)
        )) {
            if(!this.state.selectedConversation || this.props.selectedConversation.conversation.id !== prevProps.selectedConversation.conversation.id) {
                this.setState({
                    selectedConversation: this.props.selectedConversation,
                    conversationFetchTime: this.props.conversationFetchTime
                }, () => {
                    if(this.state.selectedConversation && this.state.selectedConversation.messages && this.state.selectedConversation.messages.length > 0) 
                        this.openCloseMessage(this.state.selectedConversation.messages[0].id, true)
                });
            } else {
                let finalMessages = [] 
                let newConv = this.props.selectedConversation.messages;
                let oldConv = this.state.selectedConversation.messages;

                for (let i = 0; i < newConv.length; ++i) {
                    let oldMsg = oldConv[i];
                    let newMsg = newConv[i];

                    if(!oldMsg || oldMsg.open !== true)
                        finalMessages.push(newMsg)
                    else {
                        finalMessages.push({
                            ...newMsg,
                            open: true
                        })
                    }
                }

                this.setState({
                    selectedConversation: {
                        ...this.props.selectedConversation,
                        messages: finalMessages
                    },
                    conversationFetchTime: this.props.conversationFetchTime
                });
            }
        }

        if(this.props.search !== prevProps.search && this.state.selectedConversation && this.state.selectedConversation.conversation) {
            this.getConversation(this.state.selectedConversation.conversation.id, 1, () => {
                if(this.state.selectedConversation && this.state.selectedConversation.messages && this.state.selectedConversation.messages.length > 0) 
                    this.openCloseMessage(this.state.selectedConversation.messages[0].id, true)
            });
        }

    }

    render() {
        const { t, locale, form, session } = this.props;
        const { pager, messages, selectedConversation } = this.state;

        let replyArea = (<div className='reply'>
            {selectedConversation && selectedConversation.canSendEmails && <div className='checkbox-area'>
                <Checkbox 
                    id={'chk_send_emails'}
                    initialValue={false}
                    onChange={this.handleCheckChange}
                >{t('SendEmails')}</Checkbox>
            </div>}
            <Wysiwyg 
                fieldId={this.state.reply && this.state.reply.parent_id ? "reply_" + this.state.reply.parent_id : "txt-content"} 
                className="reply-content" 
                onChange={this.handleReplyTextChanged}
                maxlength={2048}
                required={true}
                accentColors={this.props.accentColors}
                form={form}
                allowAllTags={true}
            />
            <div className="bottom-button-row">
                <button className="ant-btn ant-btn-primary full-button" onClick={() => {this.send(false)}}>
                    {t('Send')}
                </button>
                <button className="ant-btn full-button secondary" onClick={() => {this.send(true)}}>
                    {t('Save Draft')}
                </button>
                <FontAwesomeIcon icon={faTrash} className="last-button clickable" title={t('Abandon Message')} onClick={this.deleteReply}/>
            </div>
        </div>)


        let messageList = messages && messages.length > 0 && (messages.map((m) =>
            <div key={m.id} className={this.state.selectedConversation && this.state.selectedConversation.conversation
                && this.state.selectedConversation.conversation.id === m.conversationId ? "message-box clickable selected" :
            m.message_read || m.sender_id === session.userId ? "message-box clickable" : "message-box clickable unread"} onClick={() => {this.getConversation(m.conversationId)}}>
                <div className="message-box-content">
                    <span className="message-box-text sender">{t("From") + ": " + (m.sender_id === session.userId ? t("You") : m.sender)}</span>
                    <span className="message-box-text">{t("Subject") + ": " + m.subject}</span>
                    <span className="message-box-text">{t("Date") + ": " + moment(m.sentOn).format(getLanguageDateFormatByKey(locale))}</span>
                </div>
                <button className="ant-btn ant-btn-primary full-button message-box-button">
                    <FontAwesomeIcon icon={faTrash} title={t('Delete Conversation')} onClick={(e) => { this.deleteConversation(e, m.conversationId) }}/>
                </button>
            </div>
        ))

        let subjectString = null;
        let recipientString = null;
        if(this.state.selectedConversation && this.state.selectedConversation.conversation) {
            subjectString = this.state.selectedConversation.conversation.subject;
            recipientString = this.getRecipients();
        }

        let messageArea = messages && messages.length > 0 ? (
            <div className="message-area">
                <div className={"message-list" + (this.state.selectedConversation ? " convo-selected" : '')}>
                    {messageList}
                </div>
                <div className={'selected-message-area' + (this.state.selectedConversation ? " convo-selected" : '')}>
                    <div className="loading-container">
                        <div className="selected-message" ref={this.scrollRef}>
                            { this.state.selectedConversation ?
                                <div>
                                    <button className="ant-btn back-button" onClick={this.deselectConversation}>
                                        <FontAwesomeIcon icon={['fal', 'long-arrow-left']} className='back-arrow'/>
                                    </button>
                                    <div className='top-button-row'>
                                        <div className='convo-info-area'>
                                            <span className='selected-conversation-info' title={subjectString}>{t('Subject') + ": " + subjectString}</span>
                                            <span className='selected-conversation-info' title={recipientString}>{t('Recipients') + ": " + this.getRecipients()}</span>
                                        </div>
                                        <div className='button-section'>
                                            <SelectField
                                                form={form}
                                                fieldId="orderSelect"
                                                className="UserInboxOrderSelect"
                                                optionsArray={[{
                                                    value: 'newer',
                                                    text: t('Newest')
                                                }, {
                                                    value: 'older',
                                                    text: t('Oldest')
                                                }]}
                                                initialValue={this.state.oldestFirst ? 'older' : 'newer'}
                                                onChange={this.handleOrderChange}
                                                dropdownClassName="CreatePersonalizationForm__Dropdown"
                                            />
                                            <button className="ant-btn ant-btn-primary full-button slim-button" onClick={this.markSelectedAsUnread}>
                                                {t('Mark as Unread')}
                                            </button>
                                        </div>
                                    </div>
                                    <div className='message-section'>
                                        {this.state.selectedConversation.messages.map((m) => {
                                            return (<div className="message" id={"message_" + m.id} key={'message_' + m.id}>
                                                <div className="retractable-section">
                                                    <FontAwesomeIcon icon={m.open ? faCaretDown : faCaretRight} className="open-icon" onClick={() => {
                                                        this.openCloseMessage(m.id, !m.open, () => {
                                                            if(!m.open && this.state.reply && this.state.reply.parent_id === m.id) {
                                                                this.deleteReply();
                                                            }
                                                        })
                                                    }}/>
                                                    <span>{t('From')}: {m.sender}</span>
                                                    <span className="last-text">{t('Date')}: {moment(m.sentOn).format(getLanguageDateFormatByKey(locale))}</span>
                                                    <FontAwesomeIcon icon={faReply} className="first-icon clickable" title={t('Reply')} onClick={() => {this.reply(m.id)}}/>
                                                    {m.sender_id === session.userId ? <FontAwesomeIcon icon={faEdit} className="secondary-icon clickable" title={t('Edit your message')} onClick={() => {this.enterEditMode(m.id)}}/> : 
                                                    <FontAwesomeIcon icon={faBan} className="secondary-icon clickable" title={t('Block Sender')} onClick={() => {this.blockUser(m.sender_id)}}/>}
                                                    {m.sender_id === session.userId ? <FontAwesomeIcon icon={faTrash} className="last-icon clickable" title={t('Delete the message')} onClick={() => {this.deleteMessage(m.id)}}/> : 
                                                    <FontAwesomeIcon icon={faFlag} className="last-icon clickable" title={t('Report Message')} onClick={() => {this.reportMessage(m.id)}}/>}
                                                </div>
                                                {m.open ?
                                                <div>
                                                    {m.parent && m.parent.id ? <div className='parent-content'>
                                                        <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(m.parent.content, SANITIZE_HTML_CONFIG)}} />
                                                    </div> : ''}
                                                    {this.state.reply && this.state.reply.id === m.id && this.state.editMode ? <div className='editMessage'>
                                                            <Wysiwyg 
                                                                fieldId={"edit_" + m.id}  
                                                                className="reply-content" 
                                                                onChange={this.handleReplyTextChanged}
                                                                initialValue={m.content}
                                                                maxlength={2048}
                                                                required={true}
                                                                accentColors={this.props.accentColors}
                                                                form={form}
                                                                allowAllTags={true}
                                                            />
                                                            <div className="bottom-button-row">
                                                                <button className="ant-btn ant-btn-primary full-button" onClick={() => {this.confirmEdit(m.id)}}>
                                                                    {t('Confirm')}
                                                                </button>
                                                                <FontAwesomeIcon icon={faBan} className="last-button clickable" title={t('Abandon Edit')} onClick={this.leaveEditMode}/>
                                                            </div>
                                                        </div> : 
                                                        <div className="message-content" dangerouslySetInnerHTML={{__html: sanitizeHTML(m.content, SANITIZE_HTML_CONFIG)}}/>}
                                                    {this.state.reply && this.state.reply.parent_id === m.id && replyArea}
                                                </div> : ''}
                                                
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            : <h1 className="no-selected">{t('No selected message')}</h1> }
                        </div>
                        {this.props.isFetchConversationInProgress && <div className="loading-indicator"><span>.</span><span>.</span><span>.</span></div>}
                    </div>
                    {this.state.selectedConversation ? <div className='reply-area' id="reply-area">
                        {this.state.reply && this.state.reply.parent_id === null ? 
                        replyArea
                        : 
                            <button className="ant-btn ant-btn-primary full-button" onClick={() => {this.reply(null)}}>
                                {t('Reply')}
                            </button>
                        }
                    </div> : ''}
                </div>
            </div>
        ) : <h1>{t('no_messages')}</h1>

        return (
            <div className="UserInboxTab">
                <SearchBar 
                    placeholder={t('Search')} 
                    onSearch={this.handleSearch}
                />
                <div className="UserInboxForm">
                    <div className="UserInboxForm__Content">
                        <div className="under-search wrap">
                            <button className='ant-btn ant-btn-secondary refresh-button'>
                                <FontAwesomeIcon icon={faArrowsRotate} title={t('Refresh')} onClick={this.refreshList}/>
                            </button>
                            <PaginationTop
                                totalLabel={total => t('messagesTotal', { count: pager.total })}
                                pager={pager}
                                onChange={this.handlePaginationChange}
                                showSizeChanger={false}
                                className={'inbox'}
                            />
                        </div>
                        {messageArea}
                    </div>
                </div>
            </div>
        )
    }

    handleCheckChange(e) {
        this.setState({reply: {
            ...this.state.reply,
            send_emails: e.target.checked
        }})
    }

    enterEditMode(messageId) {
        this.wysiwygContent = this.state.selectedConversation.messages.find(m => m.id === messageId).content
        this.setState({
            reply: {id: messageId},
            editMode: true,
            selectedConversation: {
                ...this.state.selectedConversation,
                messages: this.state.selectedConversation.messages.map((m) => {
                    if(m.id !== messageId)
                        return m;
                    else
                        return {...m, open: true}
                })
            }
        })
    }

    leaveEditMode() {
        this.setState({
            editMode: false,
            reply: undefined
        })
    }

    confirmEdit(messageId) {
        let content = this.wysiwygContent;
        this.props.updateMessage(messageId, undefined, content).then((e) => {
            if (e.type === UPDATE_MESSAGE_SUCCESS) {
                this.setState({
                    selectedConversation: {
                        ...this.state.selectedConversation,
                        messages: this.state.selectedConversation.messages.map((m) => {
                            if(m.id === messageId) {
                                return {
                                    ...m,
                                    content: content
                                }
                            } else {
                                return m;
                            }
                        })
                    }
                }, this.leaveEditMode)
            }
        })
    }

    handleReplyTextChanged(e) {
       this.wysiwygContent = e;
    }

    reply(messageId = null) {
        if(this.state.reply && this.state.reply.parent_id === messageId)
            return;
        
        this.wysiwygContent = "";
        this.openCloseMessage(messageId, true);
        this.setState({reply: {parent_id: messageId, conversation_id: this.state.selectedConversation.conversation.id}});
    }

    openCloseMessage(id, status, callback) {
        this.setState({selectedConversation: {
            ...this.state.selectedConversation,
            messages: this.state.selectedConversation.messages.map(m => {
                if(m.id === id) {
                    m.open = status
                    if(status === false && this.state.reply && this.state.reply.id === id) {
                        this.leaveEditMode();
                    }
                }
                return m;
            })
        }}, callback);
    }

    reportMessage(messageId) {
        let reportMessageUrl = `/${this.props.locale}/d/messages/report/${messageId}`;
        return this.props.history.push(reportMessageUrl);
    }

    // Méthode générée par Copilot
    handleScroll = () => {
        const el = this.scrollRef.current;
        if (!el) return;

        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        if (atBottom && !this.props.bottomReached) {
            this.getConversation(this.state.selectedConversation.conversation.id, this.props.batchNumber + 1)
        }
    };


    getConversation(conversationId, batchNumber, callback) {
        if(this.props.isSendMessageInProgress)
            return;
        this.setRead(conversationId, true);
        this.props.fetchConversation(conversationId, this.props.search, this.state.oldestFirst, batchNumber).then((e) => {
            if(e.type === FETCH_CONVERSATION_SUCCESS) {
                this.setState({
                    reply: undefined
                }, () => { if (callback) { callback()} })
            }
        })
    }

    blockUser(senderId) {
        if(confirm(this.props.t('Confirm block'))) {
            this.props.blockUser(senderId).then((e) => {
                if (e.type === BLOCK_USER_SUCCESS) {
                    if (this.state.selectedConversation.messages.filter(m => m.sender_id !== this.props.session.userId && m.sender_id !== senderId).length === 0) {
                            this.deselectConversation();
                    }
                    this.refreshList();
                }
            });
        }
    }

    setRead(conversationId, isRead) {
        this.setState((prevState) => ({
            messages: prevState.messages && prevState.messages.map((msg) =>
                msg.conversationId === conversationId ? { ...msg, message_read: isRead } : msg
            ),
        }));
    }

    send(draft = false) {
        this.setState({reply: {
            ...this.state.reply,
            content: this.wysiwygContent,
            draft: draft,
        }}, () => {
            if(this.state.reply.content && this.state.reply.content.length > 0 && !this.isSendMessageInProgress && (!this.state.reply.send_emails || !draft)) {
                this.props.sendMessage(this.state.reply).then((e) => {
                    if(e.type === SEND_MESSAGE_SUCCESS) {
                        this.setState({reply: undefined}, () => {
                            this.getConversation(this.state.selectedConversation.conversation.id, 1, () => {
                                this.setState({selectedConversation: this.props.selectedConversation, conversationFetchTime: this.props.conversationFetchTime})

                                if(this.state.selectedConversation.messages && this.state.selectedConversation.messages.length > 0)
                                    this.openCloseMessage(this.state.selectedConversation.messages[0].id, true)
                            });
                        });
                    }
                });
            } else if (this.isSendMessageInProgress) {
                notification.error({
                    message: this.props.t('Wait'),
                    description: this.props.t('Please wait until message is sent')
                })
            } else if (this.state.reply.send_emails && draft) {
                return notification.error({
                    message: this.props.t('Cannot send emails with draft'),
                    description: this.props.t('No email notifications with draft')
                })
            } else {
                notification.error({
                    message: this.props.t('Missing content'),
                    description: this.props.t('Please give content to your message')
                })
            }
        });
    }

    deleteReply() {
        this.setState({reply: undefined});
    }

    markSelectedAsUnread() {
        let conversationId = this.state.selectedConversation.conversation.id;

        let messages = this.state.selectedConversation.messages
            .filter(m => m.sender_id !== this.props.session.userId)
            .sort((a, b) => a.sentOn < b.sentOn);

        let messageId = 0;

        if(messages && messages.length > 0)
            messageId = messages[0].id;

        if(messageId === 0) {
            notification.error({
                message: this.props.t("Can't mark as unread"),
                description: this.props.t('Cannot mark as unread when you are the only sender')
            })
            return;
        }

        this.setRead(conversationId, false);

        this.props.markAsUnread(messageId);
    }

    deselectConversation() {
        if(this.props.isSendMessageInProgress)
            return;
        this.setState({
            selectedConversation: undefined,
            reply: undefined
        });
    }

    handlePaginationChange = pager => {
        if(this.props.isSendMessageInProgress)
            return;
        this.setState({ pager }, this.refreshList);
    };

    handleOrderChange(e) {
        let callback = () => {
            this.setState({selectedConversation: this.props.selectedConversation, conversationFetchTime: this.props.conversationFetchTime})
            if(this.state.selectedConversation.messages && this.state.selectedConversation.messages.length > 0)
                this.openCloseMessage(this.state.selectedConversation.messages[0].id, true)
        }

        if(e === 'older') {
            this.setState({oldestFirst: true}, () => {
                this.getConversation(this.state.selectedConversation.conversation.id, 1, callback);
            });
        } else if(e === 'newer') {
            this.setState({oldestFirst: false}, () => {
                this.getConversation(this.state.selectedConversation.conversation.id, 1, callback);
            });
        }
    }

    deleteConversation(e, conversationId) {
        e.stopPropagation();
        if(confirm(this.props.t('Confirm delete conversation'))) { 
            this.props.deleteConversation(conversationId).then((e) => {
                if (e.type === DELETE_CONVERSATION_SUCCESS) {
                    if (this.state.selectedConversation && this.state.selectedConversation.conversation && 
                        this.state.selectedConversation.conversation.id === conversationId)
                        this.setState({selectedConversation: undefined})
                    this.refreshList();
                }
            })
        }
    }

    deleteMessage(messageId) {
        if(confirm(this.props.t('Confirm delete message'))) { 
            this.props.updateMessage(messageId, 3).then((e) => {
                if (e.type === UPDATE_MESSAGE_SUCCESS) {
                    this.setState({
                        selectedConversation: {
                            ...this.state.selectedConversation,
                            messages: this.state.selectedConversation.messages.filter(m => m.id !== messageId)
                        }
                    })
                }
            })
        }
    }

    refreshList() {
        const pagination = {
            pageNumber: this.state.pager.current,
            pageSize: PAGE_SIZE,
            totalResults: this.state.pager.total
        };

        this.props.searchMessages(this.props.platformId, this.props.search, null, pagination, { orderBy: 'addedOn[desc]' }, true);
        if(this.state.selectedConversation) {
            this.getConversation(this.state.selectedConversation.conversation.id, 1, () => {
                this.setState({selectedConversation: this.props.selectedConversation, conversationFetchTime: this.props.conversationFetchTime})
                if(this.state.selectedConversation.messages && this.state.selectedConversation.messages.length > 0)
                    this.openCloseMessage(this.state.selectedConversation.messages[0].id, true)
            });
        }
    }

    handleSearch = filters => {
        this.props.searchMessages(this.props.platformId, filters.search, filters, null, { orderBy: 'addedOn[desc]' }, true);
    }

    getRecipients() {
        let { recipients } = this.state.selectedConversation.conversation;

        return recipients.reduce((acc, r) => {
            if(r.id === this.props.session.userId)
                return acc;
            
            if (acc.length > 0)
                return acc + ', ' + r.name;
            else
                return r.name;
        }, '')
    }
}

UserInboxForm.defaultProps = {
  messages: [],
  selectedConversation: undefined,
  bottomReached: false,
  pagination: {
    totalResults: 0
  }
};

export default translate('UserInboxForm')(UserInboxForm);